import { type FormInstance, type Rule } from "antd/lib/form"
import { checkMaxNumber, checkMinNumber } from "~Components/forms/rules/utils.rules"
import { TablesEnum } from "../../../shared/store/reducers/tableConfigReducer"

export const createTransactionFilterRules = (formInstance: FormInstance, table: TablesEnum) => ({
    minTransactionAmount: [
        {
            validator: (_rule, value: number | string) => {
                const numberOptions = { arePositiveNumbersAllowed: table !== TablesEnum.TRANSACTIONS_OUTFLOW, areNegativeNumbersAllowed: table !== TablesEnum.TRANSACTIONS_INFLOW }

                return checkMinNumber({
                    formInstance,
                    value,
                    name: "maxTransactionAmount",
                    numberOptions,
                })
            },
        },
    ] as Array<Rule>,
    maxTransactionAmount: [
        {
            validator: (_rule, value: number | string) => {
                const numberOptions = { arePositiveNumbersAllowed: table !== TablesEnum.TRANSACTIONS_OUTFLOW, areNegativeNumbersAllowed: table !== TablesEnum.TRANSACTIONS_INFLOW }

                return checkMaxNumber({ formInstance, value, name: "minTransactionAmount", numberOptions })
            },
        },
    ] as Array<Rule>,
})
